import { generateAssetCdnUrl } from '@tickled-media/web-components.tm-helpers';
import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
// import { withRouter } from 'react-router';
import {connect} from 'react-redux';
import { translate } from 'react-i18next';
import {gtmSend} from '../../helpers';
import history from '../../other/history';
import {questionSave, linkPreviewFetch, topicSuggestionsFetch, resetCompose, completeLinkPreviewReset, showLoginModal} from '../../actions/index';
import GenericInputModal from '../../components/Common/CardComponents/GenericInputModal';
import ImagePopup from '../../components/Common/ImagePopup';
import ConformationPopup from "../../components/Common/ConformationPopup";
import Loader from '../../components/Common/Loader';
import {cloneEvent, esCape} from '../../helpers';
import {Icon} from '../../components/Common/Icon';
import cx from '../../styles';
// import style from './style.css';

import { myIsSet } from '@tickled-media/web-components.tm-helpers'

class ComposeContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            switchState: false,
            isAdPopupOpen: false,
            title:"",
            content:"",
            buttonLabel: props.t('add_next'),
            modalImagePreviews: [],
            modalImages: [],
            formReference: null,
            pathname: '',
            isConformationPopupShow : false,
            saveDraftValues : {},
            indexedDBDatabaseName : `questionDraft`,
            indexedDBDatabaseObjectName : `post`,
            linkPreview : {
                'linkData' : null,
                'type' : null,
                'url' : ''
            },
            gif_id : '',
            gif_url : '',
            anonymous : 0,
            isNSFWChecked : 0,
            groupId : '',
            groupName : '',
            groupImage : ''
        };
    }

    componentDidMount() {
        //ssr fix
        this.setState({pathname: history.location.pathname});
        this.createIndexedDBWithIndex(this.state.indexedDBDatabaseName, 1, this.state.indexedDBDatabaseObjectName, true, `userId`, true, true, false, false);
    }

    componentWillReceiveProps() {
        // this.createIndexedDBWithIndex(this.state.indexedDBDatabaseName, 1, this.state.indexedDBDatabaseObjectName, true, `userId`, true, true, false, false);
    }
    shouldBeVisible = () => {
        let retBool = false;
        const allowedPaths = [
            '/feed'
            //'/booth'
        ];
        const pathname = this.state.pathname;
        // if(pathname == '/') {
        //     retBool = true;
        // } 
        for(const i in allowedPaths) {
            if(pathname.indexOf(allowedPaths[i]) > -1) {
                retBool = true;
                break;
            }
        }
        if(this.props.match.url == '/feed/poll') {
            return false;
        }
        return retBool;
    }

    onBack = () => {
        gtmSend('dynamic', 'Compose', 'click-back', '');
        this.switchState(false);
    }

    switchState = (state) => {
        const t = this.props.t;
        this.setState({switchState: state, buttonLabel: state ? t('add_send') : t('add_next')});
    }

    openComposeModal = () => {
        if(!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `Whats your question | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `Whats your question | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        } else if(history.location.pathname.indexOf('/booth') > -1) {
            gtmSend('click add memories', 'memories', 'click', 'add');
            this.setState({isAdPopupOpen: true});
        } else {
            //gtmSend('click add post', 'add-post', 'click', 'add');
            this.setState({isModalOpen: true});
        }
    }

    closeComposeModal = () => {
        this.setState({isModalOpen: false});
    }

    onComposeModalOpen = () => {
        this.createIndexedDBWithIndex(this.state.indexedDBDatabaseName, 1, this.state.indexedDBDatabaseObjectName, true, `userId`, true, true, false, false);
        //dialog fix
        // const state = {};
        // history.replace({...this.props.history.location, state});
    }

    onComposeModalClose = (isConformation = false) => {

        if(isConformation) {
            return;
        }

        this.setState({isModalOpen: false, switchState: false, title:"", content:"",  buttonLabel: "next", modalImagePreviews: [], modalImages: [], formReference: null});
        this.props.completeLinkPreviewReset();
        this.props.resetCompose();
    }

    onComposeModalTitleChange = (title) => {
        this.setState({title: title});
    }

    onComposeModalContentChange = (content) => {
        //set content
        this.setState({content});
    }

    onHashClick = (hashtag) => {
        let content = this.state.content;
        content += ` ${hashtag}`;
        this.setState({content});
        document.getElementById("content").focus();
    }

    onComposeModalImageUpload = (e) => {
        if(e.target.files.length < 6 && (this.state.modalImagePreviews.length + e.target.files.length) < 6) {
            gtmSend('dynamic', 'Compose', 'click-image-upload', '');
            for(let k = 0; k < e.target.files.length; k++) {
                const reader = new FileReader();
                reader.readAsDataURL(e.target.files[k]);
                reader.onload = (i) => {
                    const base64Result = i.target.result;
                    this.setState({
                        modalImagePreviews: [...this.state.modalImagePreviews, base64Result],
                        modalImages: [...this.state.modalImages, base64Result.split(',')[1]]
                    });
                    this.props.completeLinkPreviewReset(); // to remove article preview
                };
            }
        }else{
            return this._addNotificationToModal(this.props.t('you_can_upload_upto_five_images'), 'error');
        }
    }

    onComposeModalSubmit = (e) => {               
        e.preventDefault();
        const t = this.props.t;
        // if(!this.state.switchState) {
        //     gtmSend('dynamic', 'Compose', 'click-next-stage', '');
        //     gtmSend('cw_post_compose', 'Post', 'Compose', 'Next', 0);
        //     if(!this.state.content) return this._addNotificationToModal(t('add_desc_check'), 'error');
        //     // this.state.formReference = cloneEvent(e);
        //     this.setState({formReference: cloneEvent(e)});
        //     this.switchState(true);
        //     //update suggested groups
        //     this.props.topicSuggestionsFetch(this.state.content);
        // } else {
            let formReference = this.state.formReference;
            formReference = cloneEvent(e);
            const message = esCape(this.state.content);
            if(message.length < 10) return this._addNotificationToModal(t('char_limit_desc'), 'error');
            const title = esCape(this.state.title);
            if(title.length < 10) return this._addNotificationToModal(t('char_limit_title'), 'error');
            const anonymous = parseInt(formReference.target.anonymous.value);
            const nsfw = formReference.target.nsfw ? +(formReference.target.nsfw.checked) : 0;
            const type = this.props.composeReducer.linkPreview.type || this.state.linkPreview.type;
            const groupId = e.target.groupId.value;
            const gifId = formReference.target.gifId? formReference.target.gifId.value : '';
            if(!groupId.length) return this._addNotificationToModal(t('you_need_to_select_a_topic'), 'error');
            const isActive = 1;
            const linkData = this.props.composeReducer.linkPreview.url ? this.props.composeReducer.linkPreview.linkData : this.state.linkPreview.linkData ? this.state.linkPreview.linkData : null;
            const attachement = gifId.length? 'GIF': linkData? 'Embed URL' : 'None';
            const nsfwVal = nsfw? 'True': this.state.modalImages.length? 'false' : 'None';
            if(this.state.modalImages.length) {
                let images = [];
                images = this.state.modalImages.map((image)=>{return {image};});
                this.props.questionSave(title, message, groupId, type, anonymous, nsfw, isActive, images, linkData)
                .then(()=>{this.deleteDb(this.state.indexedDBDatabaseName); this.onComposeComplete('Photo', nsfwVal)});
            } else {
                this.props.questionSave(title, message, groupId, type, anonymous, nsfw, isActive, [], linkData, gifId)
                .then(()=>{this.deleteDb(this.state.indexedDBDatabaseName); this.onComposeComplete(attachement, nsfwVal)});
            }
        // }
    }

    onComposeComplete = (attachement, nsfw) => {
        const {postReducer} = this.props;
        if(!postReducer.error){
            gtmSend('dynamic', 'Compose', 'click-submit', `submit:${postReducer.id}`);
            const userInfo = `${postReducer.data.topic? `${postReducer.data.topic.user.fullname === "Anonymous" ? 'Anonymous': 'Identified'}`: '--'}`
            //gtmSend('cw_post_submit', 'Post', 'Submit', `${postReducer.data.topic? `${postReducer.data.topic.user.fullname === "Anonymous" ? 'Anonymous': 'Identified'} - ${postReducer.data.topic.group.name}`: '--'}`, 0, {card_id: `${postReducer.id? `${postReducer.id}` : '--'}` });
            gtmSend('post_submit', 'Post', 'Submit', postReducer.data.topic? `${userInfo} - ${postReducer.data.topic.group.name}`: '--', 0, postReducer.data.topic? {action: `${userInfo} || NSFW: ${nsfw}`, group_id: postReducer.data.topic.group.id, group_name: postReducer.data.topic.group.name, attachement_type: attachement} : {});
            this.onComposeModalClose();
            if(postReducer.id){
                setTimeout(()=>{
                    history.push({pathname: `/q/${postReducer.data.topic.slug}/${postReducer.id}`});
                }, 1000);
            }
        } else {
            return this._addNotificationMessageToModal(postReducer.error, 'error');
        }
    }

    onPreviewImageRemove = (index) => {
        gtmSend('dynamic', 'Compose', 'click-remove-image-preview', '');
        this.setState({
            modalImagePreviews: [...this.state.modalImagePreviews.slice(0, index), ...this.state.modalImagePreviews.slice(index+1)],
            modalImages: [...this.state.modalImages.slice(0, index), ...this.state.modalImages.slice(index+1)]
        });
    }

    onLinkPreviewRemove = () => {
        gtmSend('dynamic', 'Compose', 'click-remove-link-preview', '');
        this.props.completeLinkPreviewReset();
        const postObject =  this.state.saveDraftValues;

        postObject[`linkPreview`] = {
            'linkData' : null,
            'type' : null,
            'url' : ''
        };
        postObject[`linkData`] = null;

        this.setState({
            saveDraftValues: postObject,
            linkPreview : {}
        }, () => {
            this.createIndexedDBWithIndex(this.state.indexedDBDatabaseName, 1, this.state.indexedDBDatabaseObjectName, true, `userId`, true, false, false, true);
        })
    }

    createMobileButton = (type, label, checkVisibility=false) => {
        const buttonType = type ? type : 'button', visibility = checkVisibility ? this.shouldBeVisible() : false;
        //
        if(buttonType == 'text') {
            return (
                <div className={cx("pointer-click", "mobile-login-button-text")} onClick={this.openComposeModal}>
                    <span>
                        <Icon name="sidebar-compose-icon-regular" />
                    </span>
                    <span>{label}</span>
                </div>
            );
        } else if(buttonType == 'button') {
            return <button className={cx("btn", "btn-round", !visibility && "hide")} onClick={this.openComposeModal}><Icon name="plus-regular-white-md" /></button>;
        } else if(buttonType == 'textbox') {
            return <div className={cx('whats-your-question-wrapper', !visibility && "hide")} onClick={this.openComposeModal}>
                        <div className={cx('btn','btn-round')}><Icon name="queston-icon" /></div>
                        <span>{label}</span>
                    </div>;
        }
    }

    onModalCloseGetStateValue = (data) => {

        const saveDraftObject = {
            "anonymous" : data.anonymous,
            'title' : esCape(this.state.title),
            'message' : esCape(this.state.content),
            'nsfw' : data.isNSFWChecked,
            'type' : this.props.composeReducer.linkPreview.type,
            'groupId' : data.groupId,
            'groupName' : data.groupName,
            'groupImage' : data.groupImage,
            'gif_id' : data.gif_id,
            'gif_url' : data.gif_url,
            'isActive' : 1,
            'linkData' : this.props.composeReducer.linkPreview.url ? this.props.composeReducer.linkPreview.linkData : null,
            'attachement':  data.gif_id ? 'GIF': this.props.composeReducer.linkPreview.linkData? 'Embed URL' : 'None',
            'nsfwVal' : data.isNSFWChecked ? 'True': this.state.modalImages.length? 'false' : 'None',
            'modalImagePreviews' : this.state.modalImagePreviews,
            'modalImages' : this.state.modalImages,
            'userId' : this.props.userReducer.id,
        }
        
        this.setState({saveDraftValues : saveDraftObject}) 

        if(this.state.title || this.state.content || data.gif_id || this.state.modalImagePreviews.length > 0 || (this.props.composeReducer.linkPreview.url || this.state.linkPreview.url)) {
            this.setState(( {isConformationPopupShow : true} ))
        } else if (Object.keys(this.state.saveDraftValues).length !== 0) {
            this.onSaveDraftCancel(false)
        } else {
            this.onComposeModalClose(false);
        }
    }
    
    onSaveDraft = () => {
        gtmSend(`post_compose`,`Post`,`Save Draft`, ``,``, {'action' : 'Save Draft'})
        this.createIndexedDBWithIndex(this.state.indexedDBDatabaseName, 1, this.state.indexedDBDatabaseObjectName, true, `userId`, true, false, true, false);
    }

    createIndexedDBWithIndex = (dbName, version = 1, dbObject, isAutoIncrement = false, indexValue, isIndexUnique = true, isReadFromDb = false, isStorePost = false, isUpdatePost = false ) => {
        const request = indexedDB.open(dbName, version);

        request.onupgradeneeded = (event) => {
            const db = event.target.result;
    
            const store = db.createObjectStore(dbObject, {
                autoIncrement: isAutoIncrement
            });
    
            store.createIndex(indexValue, indexValue, {
                unique: isIndexUnique
            });
        };

        request.onerror = (event) => {
            console.error(`Database error: ${event.target.errorCode}`);
        };

        request.onsuccess = (event) => {

            if(!this.props.userReducer.id) {
                return;
            } 

            if(isReadFromDb) {
                this.readPostFromDb(event.target.result, dbObject, `readonly`, this.props.userReducer.id, indexValue);
            }

            if(isStorePost) {
                this.savePost(event.target.result, dbObject, `readwrite`, 1, `userId`);
            }
            
            if(isUpdatePost) {
                this.updatePost(event.target.result, dbObject, `readwrite`, 1, `userId`);
            }
        }
    }

    storePostInDb = (db, dbObject, value, transactionMode = `readwrite`) => {
        const that = this;
        const txn = db.transaction(dbObject, transactionMode);

        const store = txn.objectStore(dbObject);
        
        const query = store.put(value);

        query.onsuccess = function () {
            that.setState({isConformationPopupShow : false})
            that.onComposeModalClose(false);
        };

        query.onerror = function (event) {
            console.log(event.target.errorCode);
        }

        txn.oncomplete = function () {
            db.close();
        };
    }

    readPostFromDb = (db, dbObject, transactionMode = `readonly`, id, indexValue) => {
        const that = this;
        const txn = db.transaction(dbObject, transactionMode);
        const store = txn.objectStore(dbObject);

        const index = store.index(indexValue);

        const query = index.get(id);

        query.onsuccess = () => {

            const result = query.result;
            if(result) {
                that.setState(
                    {
                        saveDraftValues : result,
                        title : result.title || '',
                        content : result.message || '',
                        ...(result.modalImagePreviews && result.modalImagePreviews.length > 0 && {modalImagePreviews: result.modalImagePreviews || []}),
                        ...(result.modalImages && result.modalImages.length > 0 && {modalImages: result.modalImages || []}),
                        ...(result.linkData && { linkPreview : {
                            'linkData' : result.linkData || null,
                            'type' :  myIsSet(result.linkData,'type') ? 'video' : myIsSet(result, 'linkData.linkPreview.type') ? null : `article`,
                            'url' : result.linkData ? result.linkData.url : ''
                        },}),
                        gif_id : result.gif_id || '',
                        gif_url : result.gif_url || '',
                        anonymous : result.anonymous || 0,
                        isNSFWChecked : result.nsfw,
                        groupId : result.groupId || '',
                        groupImage : result.groupImage || '',
                        groupName : result.groupName || ''
    
                    }
                )
            }
           
            return query.result;
        };

        query.onerror = () => {
            return {}
        }

        txn.oncomplete = function () {
            db.close();
        };
    }

    savePost = (db, dbObject, transactionMode = `readwrite`) => {

        const that = this;
        const txn = db.transaction(dbObject, transactionMode);

        const store = txn.objectStore(dbObject);
        
        const query = store.clear();

        query.onsuccess = function () {
            that.storePostInDb(db, dbObject, that.state.saveDraftValues, `readwrite`);
        };

        query.onerror = function (event) {
            console.log("delete not done",event.target.errorCode);
        }

        txn.oncomplete = function () {
            db.close();
        };
    }

    deleteDb = (dbName) => {
        const request = indexedDB.deleteDatabase(dbName);

        request.onerror = () => {
            console.error("Error deleting database.");
        };
          
        request.onsuccess = () => {
            console.log("Database deleted successfully");
        };
    }
    
    updatePost = (db, dbObject, transactionMode = `readwrite`) => {

        const that = this;
        const txn = db.transaction(dbObject, transactionMode);

        const store = txn.objectStore(dbObject);
        
        const query = store.clear();

        query.onsuccess = function () {

            const transaction = db.transaction(dbObject, transactionMode);
    
            const storeObject = transaction.objectStore(dbObject);
            
            const query = storeObject.put(that.state.saveDraftValues);
    
            query.onsuccess = function () {
                console.log(`update successfully`);
            };
    
            query.onerror = function (event) {
                console.log(event.target.errorCode);
            }
    
            transaction.oncomplete = function () {
                db.close();
            };
        };

        query.onerror = function (event) {
            console.log("delete not done",event.target.errorCode);
        }

        txn.oncomplete = function () {
            db.close();
        };
    }
    onSaveDraftCancel = (isConformationPopupShow) => {
        gtmSend(`post_compose`,`Post`,`Cancel Draft`, ``,``, {'action' : 'Cancel Draft'})
        this.setState(
            { 
                isConformationPopupShow : isConformationPopupShow,
                saveDraftValues : {},
                indexedDBDatabaseName : `questionDraft`,
                indexedDBDatabaseObjectName : `post`,
                linkPreview : {
                    'linkData' : null,
                    'type' : null,
                    'url' : ''
                },
                gif_id : '',
                gif_url : '',
                anonymous : 0,
                isNSFWChecked : 0,
                groupId : '',
                groupName : '',
                groupImage : '',
                title:"",
                content:"",
                modalImagePreviews: [],
                modalImages: [],

            }
            
        ); 
        this.deleteDb(this.state.indexedDBDatabaseName); 
        this.onComposeModalClose(isConformationPopupShow)
    }

    removeGif = () => {
        this.setState({
            gif_id : '',
            gif_url : ''
        })

        const postObject =  this.state.saveDraftValues;

        postObject[`gif_id`] = ``;
        postObject[`gif_url`] = ``;

        this.setState({
            saveDraftValues: postObject
        }, () => {
            this.createIndexedDBWithIndex(this.state.indexedDBDatabaseName, 1, this.state.indexedDBDatabaseObjectName, true, `userId`, true, false, false, true);
        })
    }
    render(){
        const {t, composeReducer, userReducer, match, feedReducer} = this.props,
        customStyles = {
            content: {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)'
            }
        },
        eventHandlers = {
            onModalOpen: this.onComposeModalOpen,
            onModalClose: this.onComposeModalClose,
            onSubmit: this.onComposeModalSubmit,
            onImageUpload: this.onComposeModalImageUpload,
            onTitleChange: this.onComposeModalTitleChange,
            onContentChange: this.onComposeModalContentChange,
            onHashClick: this.onHashClick,
            onPreviewImageRemove: this.onPreviewImageRemove,
            onLinkPreviewRemove: this.onLinkPreviewRemove,
            refAddNotification: (f) => this._addNotificationToModal = f,
            refAddNotificationMessage: (f) => this._addNotificationMessageToModal = f,
            onBack: this.onBack,
            onModalCloseGetStateValue : (obj) => this.onModalCloseGetStateValue(obj),
            onGifRemove: this.removeGif
        };

        //image popup
        const desktopImg = generateAssetCdnUrl("parenttown-prod/community/memory_app", "TAP_Apps_Popupbanner_Desktop_Blue.png"),
            mobileImg = generateAssetCdnUrl("parenttown-prod/community/memory_app", "TAP_Apps_Popupbanner_Mobile_Blue.png");
        
        return (
            <div>   
                { composeReducer.isLoading && <Loader /> }

                {/*
                    this.props.isMobile
                    ?
                    this.createMobileButton(this.props.buttonType, t('whats_your_question'), this.props.checkVisibility)
                    :
                    <button className={cx("btn", "btn-primary", "full-width", "ask-question-btn")} onClick={this.openComposeModal}>{t('menu_compose')}</button>
                */}

                {/*
                    this.createMobileButton(this.props.buttonType, t('whats_your_question'), this.props.checkVisibility)
                */}
                {
                    match.path === '/feed' &&
                    <div className={cx('whats-your-question-wrapper')} onClick={this.openComposeModal}>
                        <div className={cx('btn','btn-round')}><Icon name="queston-icon" /></div>
                        <span>{t('whats_your_question')}</span>
                    </div>
                }

                <ImagePopup isModalOpen={this.state.isAdPopupOpen}
                    onClose={()=>this.setState({isAdPopupOpen: false})}
                    url={"https://community.theasianparent.com/app/download?utm_source=community-static-banner&utm_medium=web&utm_campaign=app-download"}
                    imgUrlDesktop={desktopImg}
                    imgUrlMobile={mobileImg} />


                <GenericInputModal isModalOpen={this.state.isModalOpen}
                    eventHandlers={eventHandlers}
                    gtmLabel={'Compose'}
                    content={this.state.content}
                    title={this.state.title}
                    imagePreviews={this.state.modalImagePreviews}
                    linkPreview={composeReducer.linkPreview.linkData ? composeReducer.linkPreview : this.state.linkPreview}
                    topicSuggestions={composeReducer.topicSuggestions}
                    user={userReducer}
                    buttonLabel={this.state.buttonLabel}
                    showUploadInput={true}
                    showUploadGif={true}
                    showUploadEmbed={true}
                    showNSFW={true}
                    showHash={true}
                    isCompose={true}
                    groupId={feedReducer.currentFilterId? feedReducer.currentFilterId : this.state.groupId ? this.state.groupId : ''}
                    switchState={this.state.switchState}
                    style={customStyles}
                    contentPlaceholder={t('post_description')}
                    mobileTitle={t('add_send')} 
                    gif_id={this.state.gif_id || ''}
                    gif_url={this.state.gif_url || ''}
                    anonymous={this.state.anonymous || 0}
                    isNSFWChecked={this.state.isNSFWChecked || 0}
                    groupName={this.state.groupName || ``}
                    groupImage={this.state.groupImage || ``}
                    />

                {
                    this.state.isConformationPopupShow && 
                    <ConformationPopup 
                        isOpen={this.state.isConformationPopupShow}
                        headingText={this.props.t('save_draft_queston')}
                        descriptionText={this.props.t('save_draft_description')}
                        conformationBtnText={this.props.t('add_edit_save')}
                        cancelBtnText={this.props.t('cancel')}
                        onConformation={() => {this.onSaveDraft()}}
                        onCancel={(isConformation) => {this.onSaveDraftCancel(isConformation)}}
                    />
                }
                
            </div>
        );
    }
}

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
};

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        questionSave,
        linkPreviewFetch,
        topicSuggestionsFetch,
        resetCompose,
        completeLinkPreviewReset,
        showLoginModal
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(ComposeContainer));
